Auth = require 'db/auth'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Reaction = require 'models/reaction'
Util = require 'lib/util'
_ = require 'underscore'


module.exports = class ReactionList extends CollectionWithHelpers
  model: Reaction

  initialize: ->
    @_pendingReactionUpdates = {}

  comparator: (reaction) ->
    Util.idToDate(reaction.id)

  findMyReaction: (emoji) ->
    @find (entry) =>
      entry.get('idMember') == Auth.myId() && \
        # eventually once we allow all reactions, we can simply compare
        # unified value to idEmoji, but until then, we need to account for
        # the limited selector adding values as strings equal
        # to the emoji shortname
        (entry.get('idEmoji') == emoji.unified?.toUpperCase() ||
        # this is the case where we add an emoji from a pile if a user is
        # using a limited selector, but the reaction hasn't saved to the server
        entry.get('emoji') == emoji.id)

  # Track function Returns true or false, for added or removed, respectively.
  toggleReaction: (actionId, emoji, trackFn) ->
    emojiId = if emoji.unified? then emoji.unified.toUpperCase() else emoji
    existing = @findMyReaction(emoji)
    if existing?
      @remove(existing)
      @_registerReactionUpdate
        idReaction: emojiId,
        updateFn: =>
          trackFn(false)
          existing.destroy()
        model: existing
    else
      model = @_pendingReactionUpdates[emojiId]?.model ||
        new Reaction {
          idModel: actionId
          idMember: Auth.myId()
          idEmoji: emojiId
          # this emoji object is not needed for the server payload
          # but allows us to render the reaction immediately upon adding to the model
          emoji: emoji
        }, { @modelCache }
      @add model
      @_registerReactionUpdate
        idReaction: emojiId,
        updateFn: =>
          trackFn(true)
          model.save()
        model

  _registerReactionUpdate: ({ idReaction, updateFn, model }) ->
    if @_pendingReactionUpdates[idReaction]?
      # Remove from pending updates, the user has just cancelled that operation
      delete @_pendingReactionUpdates[idReaction]
    else
      @_pendingReactionUpdates[idReaction] = {
        updateFn,
        model
      }

    @_debouncedPersistUpdates()

  _debouncedPersistUpdates: _.debounce ->
    _.each @_pendingReactionUpdates, ({ updateFn }) -> updateFn()
    @_pendingReactionUpdates = {}
  , 1000



// WEBPACK FOOTER //
// ./app/scripts/models/collections/reaction-list.coffee